import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import * as serviceWorker from './serviceWorker';
import Navigation from './pages/index';


ReactDOM.render( <Navigation/> , document.getElementById('root'));

serviceWorker.unregister();